<div class="pkt-color-field" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip">
  <label *ngIf="label && labelPosition === 'top'" class="pkt-color-label">{{ label }}</label>
  <div class="pkt-color-row">
    <label *ngIf="label && labelPosition === 'left'" class="pkt-color-label pkt-color-label--inline">{{ label }}</label>
    <input #colorEl type="color" class="pkt-color-swatch" [value]="value" [disabled]="disabled"
      (input)="onColorInput(colorEl.value)" />
    <label *ngIf="label && labelPosition === 'right'" class="pkt-color-label pkt-color-label--inline">{{ label }}</label>
  </div>
</div>
